import LoadingButton from "@mui/lab/LoadingButton";
import { SxProps } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";

interface IAppButton extends ButtonProps {
  label: string;
  type?: "button" | "submit";
  isLoading?: boolean;
  sx?: SxProps;
  onClick?: VoidFunction;
}

const AppButton: React.FC<IAppButton> = (props) => {
  const { label, type = "submit", isLoading = false, onClick, sx } = props;

  return (
    <LoadingButton
      type={type}
      variant="contained"
      fullWidth
      loading={isLoading}
      onClick={onClick}
      sx={{
        color: "white",
        textTransform: "none",
        background:
          "linear-gradient(45deg,rgb(41, 173, 225),rgb(255, 102, 204))",
        fontSize: 20,
        fontWeight: 700,
        p: 1,
        borderRadius: "40px",
        border: "1px solid #0F1316",
        "& .MuiCircularProgress-root": {
          color: "white",
        },
        "&:hover": {
          backgroundColor: "linear-gradient(45deg, #a9e7ff, #ffa3e1)",
        },
        ...sx,
      }}
    >
      {label}
    </LoadingButton>
  );
};

export default AppButton;
